export const getXYPositon = (
  anchorElement,
  targetElement,
  options = {
    centerVertically: false,
    centerHorizontally: false,
    alignLeftOnMaxWidth: false,
  }
) => {
  let topPosition = 0;
  let leftPosition = 0;
  if (anchorElement && targetElement && targetElement.getBoundingClientRect) {
    let originPosition = anchorElement.getBoundingClientRect
      ? anchorElement.getBoundingClientRect()
      : anchorElement;
    let targetPosition = targetElement.getBoundingClientRect();

    let maxHeight = window.innerHeight - 10;
    let maxWidth = window.innerWidth - 10;

    topPosition =
      originPosition.y +
      (options.centerVertically
        ? originPosition.height / 2 - targetPosition.height / 2
        : 0);
    topPosition =
      topPosition + targetPosition.height > maxHeight
        ? topPosition - (topPosition + targetPosition.height - maxHeight)
        : topPosition;
    leftPosition =
      originPosition.x +
      (options.centerHorizontally
        ? originPosition.width / 2 - targetPosition.width / 2
        : originPosition.width);
    if (options.alignLeftOnMaxWidth) {
      leftPosition =
        leftPosition + targetPosition.width > maxWidth
          ? leftPosition - originPosition.width - targetPosition.width
          : leftPosition;
    } else {
      leftPosition =
        leftPosition + targetPosition.width > maxWidth
          ? leftPosition - (leftPosition + targetPosition.width - maxWidth)
          : leftPosition;
    }
  }
  return { top: topPosition, left: leftPosition };
};
